"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unclusteredPointLayer = exports.clusterLayer = exports.clusterCountLayer = void 0;
const clusterLayer = {
  id: 'clusters',
  type: 'circle',
  source: 'cluster-source',
  filter: ['has', 'point_count'],
  paint: {
    // 'circle-color': ['step', ['get', 'point_count'], '#51bbd6', 100, '#f1f075', 750, '#f28cb1'],
    'circle-color': ['step', ['get', 'point_count'], '#00205B', 100, '#002B7A', 750, '#2D78C6'],
    'circle-radius': ['step', ['get', 'point_count'], 20, 100, 25, 750, 30]
  }
};
exports.clusterLayer = clusterLayer;
const clusterCountLayer = {
  id: 'cluster-count',
  type: 'symbol',
  source: 'cluster-source',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    // 'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 18
  },
  paint: {
    'text-color': 'white'
  }
};
exports.clusterCountLayer = clusterCountLayer;
const unclusteredPointLayer = {
  id: 'marker',
  type: 'symbol',
  source: 'cluster-source',
  layout: {
    'icon-image': 'icon-marker',
    // 'icon-allow-overlap': true,
    'icon-size': 0.9,
    'icon-anchor': 'bottom',
    // "text-field": "Put the text in here",
    'text-field': ['get', 'street'],
    // "text-font": ["Open Sans Bold", "Arial Unicode MS Bold"],
    'text-font': ['literal', ['Arial Unicode MS Regular']],
    // "text-font": ["Ubuntu,sans-serif"],
    'text-size': 18,
    // "text-transform": "uppercase",
    // "text-letter-spacing": 0.05,
    // "text-offset": [0, 1.5]
    'text-offset': [0, -4.8]
  },
  filter: ['!', ['has', 'point_count']],
  paint: {
    'text-color': '#00205b',
    'icon-opacity': ['case', ['boolean', ['feature-state', 'hover'], false], 0.8, 1]
  }
};
exports.unclusteredPointLayer = unclusteredPointLayer;